// @flow

/**
 * Location type constants
 * @type {Object}
 * @private
 */
export const LOCATION_TYPE = {
  AIRPORT: 'airport',
  PLACE: 'place',
}
